import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-stage-name',
  templateUrl: './stage-name.component.html',
  styleUrls: ['./stage-name.component.scss']
})
export class StageNameComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
